import React from 'react';

export const NonInput = React.memo(function NonInput({ children }) {
  return children;
});
